import { VariantType } from 'notistack';

interface ResponseSnackProps {
  variant: VariantType;
  message: string;
  enqueueSnackbar: (message: string, options?: object) => void;
  onClose?: () => void;
  onClick?: () => void;
}

export const showRemoteCommandResponseSnack = ({
  variant,
  message,
  enqueueSnackbar,
  onClose,
  onClick,
}: ResponseSnackProps) => {
  if (typeof enqueueSnackbar !== 'function') {
    return;
  }

  enqueueSnackbar(message, {
    variant,
    autoHideDuration: 3000,
    preventDuplicate: true,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
    onClose,
    onClick,
  });
};
